function finiteAmount(raw) {
  if (raw == null || String(raw).trim() === '') return null
  const n = Number(String(raw).replace(/,/g, '').trim())
  if (!Number.isFinite(n)) return null
  return n
}

/** SAP ledger (LC_BAL) for pay-with-balance (matches backend resolveLedgerBalance). */
export function ledgerBalanceAmount(balance) {
  if (!balance || balance.customer_balance_ok === false) return null
  const n = finiteAmount(balance.ledger_balance ?? balance.ledgerBalance)
  if (n == null) return null
  return Math.abs(n)
}

/** @deprecated Use ledgerBalanceAmount — kept for imports during rename. */
export function creditExposureAmount(balance) {
  return ledgerBalanceAmount(balance)
}

export function ledgerBalanceCoversOrder(ledger, payable) {
  if (ledger == null || payable == null) return false
  return Math.round(ledger * 100) > Math.round(payable * 100)
}

/** @deprecated Use ledgerBalanceCoversOrder */
export function creditExposureCoversOrder(exposure, payable) {
  return ledgerBalanceCoversOrder(exposure, payable)
}
